import { make } from 'vuex-pathify'
import Ticket from '@/api/ticket'

const ticketDefault = {
  messages: [],
  task: {},
  user: {},
  files: []
}

const state = {
  ticket: {
    ...ticketDefault
  }
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),

  PUSH_MESSAGE_TO_TICKET: (state, payload) => {
    state.ticket.messages.push(payload)
  }
}

const actions = {
  async create({ commit, dispatch }, data) {
    try {
      const response = await Ticket.create(data)
      commit('SET_TICKET', {
        ...response.data.ticket
      })
      commit('task/PUSH_TASK_TICKET', response.data.ticket, { root: true })
      dispatch('notify/show', response.message, { root: true })
      return response
    } catch (e) {
      return false
    }
  },

  async getTicket({ commit }, id) {
    const params = {
      _include: ['messages', 'messages.files', 'messages.user', 'task.project', 'files', 'user']
    }

    try {
      commit('SET_TICKET', ticketDefault)

      const response = await Ticket.getTicket(id, params)

      commit('SET_TICKET', response.data.ticket)

      return response
    } catch (e) {
      return false
    }
  },

  async createMessage({ commit, dispatch }, data) {
    try {
      const response = await Ticket.createMessage(data)

      commit('PUSH_MESSAGE_TO_TICKET', response.data.message)

      dispatch('notify/show', response.message, { root: true })
      return response
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
